import { testimonials } from '@/mocks/comics';

export default function Testimonials() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            读者<span className="text-accent-500">口碑</span>
          </h2>
          <p className="text-sm text-foreground-500 mt-3">来自漫画爱好者的真实评价</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="bg-background-50 rounded-2xl p-6 md:p-7 flex flex-col"
            >
              {/* Stars */}
              <div className="flex items-center gap-0.5 mb-4">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>

              {/* Comment */}
              <p className="text-sm text-foreground-700 leading-relaxed flex-1">
                &ldquo;{t.comment}&rdquo;
              </p>

              {/* User info */}
              <div className="flex items-center gap-3 mt-5 pt-5 border-t border-background-200/60">
                <div className="w-10 h-10 rounded-full overflow-hidden shrink-0">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-400">{t.date}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}